import ipv4 from 'app/forms/validations/ipv4';
import port from 'app/forms/validations/port';

function fn(value) {
  if (value) {
    if (typeof value === 'string') {
      /*

      Expecting:
        ipNumber with port
      Examples:
        2.2.2.2
        2.2.2.2:8080

      */
      const portIndex = value.lastIndexOf(':');
      const hasPort = portIndex > -1;

      // Extract parts based on detected pattern
      let ipString;
      let portString;

      if (hasPort) {
        // Format: IP:PORT
        ipString = value.substring(0, portIndex);
        portString = value.substring(portIndex + 1);
      } else {
        // Format: IP only
        ipString = value;
      }

      // Validate each part
      if (!ipv4.fn(ipString)) {
        return false;
      }

      if (hasPort && (!port.fn(portString) || portString === '')) {
        return false;
      }
    }
    return true;
  }

  return true;
}

export default {
  message: 'Enter a valid IPv4 address. Optional port number is supported.',
  fn
};
